var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',[_vm._v("<注意>当ページに掲載されている全ての画像は転載禁止です。")]),_c('div',[_vm._v("Copyright © 2020 Office RURI. All rights reserved")])])}]

export { render, staticRenderFns }